import AppPageMetadata from '../../../../../../domain/core/AppPageMetadata';
import { Card, Row, Col, Button } from 'antd';
import IntlMessages from '../../../../../../domain/utility/IntlMessages';
import { MdOutlineColorLens } from 'react-icons/md';
import { useEffect, useState } from 'react';
import { useBreadcrumbContext } from '../../../../../../domain/utility/AppContextProvider/BreadcrumbContextProvider';
import LanguageCode from '../../../../../../shared/services/types/language-code';
import ManageSubColorLanguage from './manage-sub-color-language';
import LanguagesTab from '../../../../../../shared/components/languages-tab';
import { useIntl } from 'react-intl';
import { Formik } from 'formik';
import { Form } from 'formik-antd';
import { BsCheckLg, BsFillArrowLeftCircleFill } from 'react-icons/bs';
import ManageSubColorTable from './manage-sub-color-table';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { productAttributesService } from '../../../../../../shared/services/product-attribute';
import { PredefinedColorValueSubColorListDto } from '../../../../../../shared/services/product-attribute/dto/predefined-color-value-sub-color-list-dto';
import { IPaginateProducts } from 'src/shared/common-dtos/get-all-paginate';
import {
  PAGE_NUMBER,
  PRODUCT_NUMBER_IN_ONE_PAGE,
} from 'src/shared/constants/AppConst';
import MainUtils from 'src/shared/utils/main';
import { useLocaleContext } from 'src/domain/utility/AppContextProvider/LocaleContextProvide';

interface IMangeSubColorProductAttributesProps { }

const MangeSubColorProductAttributes = (
  props: IMangeSubColorProductAttributesProps,
) => {
  const { setBreadcrumb }: any = useBreadcrumbContext();

  const { messages } = useIntl();

  const navigate = useNavigate();

  const location = useLocation();

  const { id } = useParams();

  const [subColorList, setSubColorList] = useState<
    PredefinedColorValueSubColorListDto[]
  >([]);
  const [subColorListTotal, setSubColorListTotal] = useState(0);
  const [isTableLoading, setIsTableLoading] = useState(false);
  const { locale }: any = useLocaleContext();
  const [pagination, setPagination] = useState<IPaginateProducts>({
    Page: PAGE_NUMBER,
    PageSize: PRODUCT_NUMBER_IN_ONE_PAGE,
  });

  useEffect(() => {
    setBreadcrumb([
      {
        text: <IntlMessages id='Catalog.sideBarName' />,
        url: '/catalog/products',
      },
      {
        text: <IntlMessages id='catalog.attributes' />,
        url: '/catalog/catalog.attributes/product-attributes',
      },
      {
        text: <IntlMessages id='catalog.productAttributes' />,
        url: '/catalog/catalog.attributes/product-attributes',
      },
    ]);
  }, []);

  useEffect(() => {
    if (id) {
      (async () => {
        try {
          setIsTableLoading(true);
          let subColorListAll =
            await productAttributesService.getPredefinedColorValueSubColorList({
              id: id,
              Page: pagination.Page,
              PageSize: pagination.PageSize,
            });
          setSubColorList(subColorListAll?.Data);
          setSubColorListTotal(subColorListAll?.Total);
        } catch (error) {
          console.error(error);
        } finally {
          setIsTableLoading(false);
        }
      })();
    }
  }, [id, pagination]);

  const langComponent = [
    {
      code: LanguageCode.English,
      langComponent: (
        <ManageSubColorLanguage code={LanguageCode.English} index={0} />
      ),
    },
    {
      code: LanguageCode.Español,
      langComponent: (
        <ManageSubColorLanguage code={LanguageCode.Español} index={1} />
      ),
    },
    {
      code: LanguageCode.Arabic,
      langComponent: (
        <ManageSubColorLanguage code={LanguageCode.Arabic} index={2} />
      ),
    },
  ];

  const getSubColorList = async () => {
    try {
      setIsTableLoading(true);
      let subColorListAll =
        await productAttributesService.getPredefinedColorValueSubColorList({
          id: id,
          Page: pagination.Page,
          PageSize: pagination.PageSize,
        });
      setSubColorList(subColorListAll.Data);
      setSubColorListTotal(subColorListAll?.Total);
    } catch (error) {
      console.error(error);
    } finally {
      setIsTableLoading(false);
    }
  };

  const handleSubmit = async (
    values: any,
    setSubmitting: any,
    resetForm: any,
  ) => {
    try {
      await productAttributesService.createValueSubColor({
        ...values,
        mainColorId: id ?? '',
      });
      await getSubColorList();
      resetForm();
    } catch (error) {
      console.error(error);
    } finally {
      setSubmitting(false);
    }
  };

  const initialValues: any = {
    name: '',
  };

  return (
    <AppPageMetadata
      title={messages[
        'productAttributes.productAttributesPredefinedValues.mangeSubColor'
      ].toString()}>
      <Card>
        <Formik
          enableReinitialize
          initialValues={initialValues}
          onSubmit={(values, { setSubmitting, resetForm }: any) =>
            handleSubmit(values, setSubmitting, resetForm)
          }
          validateOnChange={false}
          validateOnBlur={false}>
          {({ handleSubmit, isSubmitting, values }: any) => (
            <Form onSubmitCapture={handleSubmit}>
              <Row gutter={[0, 20]}>
                <Col span={24}>
                  <div className='text-title'>
                    <span className='icon-title'>
                      <MdOutlineColorLens />
                    </span>
                    {location?.state?.Locales?.find(
                      (item: any) => item.LanguageId === locale.code,
                    )?.LocaleValue ?? location?.state?.name}
                    <small className='back-to-list'>
                      <BsFillArrowLeftCircleFill className='back-to-icon' />
                      <a
                        onClick={() => {
                          navigate(-1);
                        }}>
                        <IntlMessages id='productAttributes.backToEditProductAttribute' />
                      </a>
                    </small>
                  </div>
                </Col>

                <Col span={24}>
                  <div className='languages-tab'>
                    <LanguagesTab
                      languagesList={langComponent}
                      tabItem={{
                        key: 'Standard',
                        label: `${messages[
                          'category.categoryInfo.Standard'
                        ].toString()}`,
                        children: (
                          <ManageSubColorLanguage
                            code={`${!MainUtils.isEmptyValue(locale.code)
                                ? locale.code
                                : LanguageCode.English
                              }`}
                          />
                        ),
                      }}
                    />
                  </div>
                </Col>

                <Col span={24}>
                  <Row justify='end'>
                    <Col>
                      <Button
                        icon={<BsCheckLg className='add-button-icon' />}
                        onClick={handleSubmit}
                        disabled={!values?.name}
                        type='primary'
                        size='small'
                        className='add-button'
                        htmlType='submit'
                        loading={isSubmitting}>
                        {messages['common.save'].toString()}
                      </Button>
                    </Col>
                  </Row>
                </Col>

                <Col span={24}>
                  <ManageSubColorTable
                    subColorList={subColorList}
                    pagination={pagination}
                    setPagination={setPagination}
                    subColorListTotal={subColorListTotal}
                    isTableLoading={isTableLoading}
                    getSubColorList={async () => {
                      await getSubColorList();
                    }}
                  />
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </Card>
    </AppPageMetadata>
  );
};

export default MangeSubColorProductAttributes;
